import { formatDate } from "../utils/format-utils";

export default class ServiceCoordinationNote {
  serviceCoordinationNoteId?: number;
  dateOfService?: Date | null;
  startTime?: Date | string | null;
  endTime?: Date | string | null;
  providerId?: number | null;
  providerName?: string | null;
  clientId?: number | null;
  clientName?: string | null;
  clientDateOfBirth?: Date | null;
  clientNyeisId?: string | null;
  visitTypeId?: number | null;
  visitTypeDescription?: string | null;
  noteText?: string | null;
  isISC?: boolean | null;
  isApproved?: boolean | null;
  editedAt?: Date | null;
  processedAt?: Date | null;
  lastNotificationSentAt?: Date | null;
  scNoteFileId?: number | null;
  scSignatureId?: number | null;
  public constructor(
    params: ServiceCoordinationNote = {} as ServiceCoordinationNote
  ) {
    let {
      serviceCoordinationNoteId = 0,
      dateOfService = null,
      startTime = null,
      endTime = null,
      providerId = null,
      providerName = null,
      clientId = null,
      clientName = null,
      clientDateOfBirth = null,
      clientNyeisId = null,
      visitTypeId = null,
      visitTypeDescription = null,
      noteText = null,
      isISC = null,
      isApproved = null,
      editedAt = null,
      processedAt = null,
      lastNotificationSentAt = null,
      scNoteFileId = null,
      scSignatureId = null,
    } = params;
    this.serviceCoordinationNoteId = serviceCoordinationNoteId;
    this.dateOfService = dateOfService;
    this.startTime = startTime;
    this.endTime = endTime;
    this.providerId = providerId;
    this.providerName = providerName;
    this.clientId = clientId;
    this.clientName = clientName;
    this.clientDateOfBirth = clientDateOfBirth;
    this.clientNyeisId = clientNyeisId;
    this.visitTypeId = visitTypeId;
    this.visitTypeDescription = visitTypeDescription;
    this.noteText = noteText;
    this.isISC = isISC;
    this.isApproved = isApproved;
    this.editedAt = editedAt;
    this.processedAt = processedAt;
    this.lastNotificationSentAt = lastNotificationSentAt;
    this.scNoteFileId = scNoteFileId;
    this.scSignatureId = scSignatureId;
  }

  get noteId() {
    return this.serviceCoordinationNoteId;
  }

  get formattedClientDob() {
    return formatDate(this.clientDateOfBirth);
  }

  get formattedDateOfService() {
    return formatDate(this.dateOfService);
  }
}
